import { render, staticRenderFns } from "./AdditionalTenantsForm.vue?vue&type=template&id=24d8d414&scoped=true&"
import script from "./AdditionalTenantsForm.vue?vue&type=script&lang=ts&"
export * from "./AdditionalTenantsForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d8d414",
  null
  
)

export default component.exports